import React from 'react';
import banner from '../../../images/banner/banner.png'

const Banner = () => {
    return (
        <div className="banner">
            <img className="mb-5 img-fluid"src={banner} alt="" />
        </div>
    );
};

export default Banner;